import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImgTechRecommender from "../assets/img/projects/project-img-tech-recommender.png"
import projImgDroneClassificator from "../assets/img/projects/project-img-drone-classificator.png"
import projImgScorePredictor from "../assets/img/projects/project-img-xgm-classifier.png"
import projImgBookLibrary from "../assets/img/projects/project-img-book-library.png"
import projImgChat from "../assets/img/projects/proj-ui_chat.png"
import projImgTrading from "../assets/img/projects/proj-ai-trader-2.png"
import projImgCars from "../assets/img/projects/proj-img-cars-api.png"
import projImgDamageClassifier from "../assets/img/projects/proj-damage-classifier.png"
import projImgDjango from "../assets/img/projects/proj-img-django.png"
import projImgDbt from "../assets/img/projects/proj-img-dbt.png"
import projImgTool from "../assets/img/projects/proj-img-cli-tool.png"
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projectsDS = [
    {
      title: "Tech recommender",
      description: "System that forecast possible know technologies for a people with a different specialities.",
      imgUrl: projImgTechRecommender,
      link: "https://github.com/FilipSzmid/SXI-Tech-Recommender",
    },
    {
      title: "Album score predictor",
      description: "Music album popularity prediction classic ML model showcasting MLOps, versioning, feature selection, cross valdiation and concept drift.",
      imgUrl: projImgScorePredictor,
      link: "https://github.com/FilipSzmid/PN-Album-Popularity",
    },
    {
      title: "Memory RAG",
      description: "High-performance personal memory system featuring Adaptive Context Injection and RRF. Combines K-NN Vector Search with BM25 Keyword Retrieval for high-precision conversational grounding.",
      imgUrl: projImgChat,
      link: "https://github.com/FilipSzmid/Memory-RAG",
    }];

  const projectsWD = [
    {
      title: "Book library app. (Flask)",
      description: "Application used for book\n" +
        "trading hosted on AWS Elastic Beanstalk with\n" +
        "AWS RDS.",
      imgUrl: projImgBookLibrary,
      link: "https://github.com/FilipSzmid/Book-Library-App",
    },
    {
      title: "Algorithmic trading.\n",
      description: "I created FastAPI with multiply page Streamlit app for forecasting stock prices. " +
        "I stream data from Binance API to SQLite and forecast using ARIMA and Fbprophet models.",
      imgUrl: projImgTrading,
      link: "https://github.com/FilipSzmid/AV-Binance-Trading",
    },
          {
      title: "Handwritten text classifier",
      description: "Report scanner and classifier with streamlit dashboard and FastAPI.",
      imgUrl: projImgDamageClassifier,
      link: "https://github.com/filipszmid/BN-Damage-Classifier",
    },
    // {
    //   title: "Cars API (Django Rest)",
    //   description: "REST API which allow adding in case it exists in external online catalogue, deleting and updating the car information." +
    //     " User can rate the car and review the average score.",
    //   imgUrl: projImgCars,
    //   link: "https://github.com/FilipSzmid/NG-CarApp",
    // },
  ];

  const projectsDO = [
    {
      title: "Django",
      description: "Complete CI/CD configuration for Django production web application.",
      imgUrl: projImgDjango,
      link: "https://github.com/FilipSzmid/BP-Test-Django",
    },
    {
      title: "DBT",
      description: "Complete CI/CD configuration for data warehouse.",
      imgUrl: projImgDbt,
      link: "https://github.com/FilipSzmid/BP-Test-Dbt",
    },
    {
      title: "CLI",
      description: "Complete CI/CD configuration for command line interface tool.",
      imgUrl: projImgTool,
      link: "https://github.com/FilipSzmid/BP-Test-Package",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility once>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Pet projects</h2>
                  <p>A collection of personal and open-source projects where I experiment freely -
                    exploring new tech stacks, sharpening algorithms, and turning ideas into working software.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="first">Data Science</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Machine Learning</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">MLOps</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                      <Tab.Pane eventKey="first">
                        <p>I feel satisfied using my Mathematical background in practical AI powered products.</p>
                        <Row>
                          {
                            projectsDS.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <p>I have a strong expertise in web development which makes me understand of how to efficiently deploy ML models and design architecture.</p>
                        <Row>
                          {
                            projectsWD.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <p>I'm a big fan of self made generic CI/CD approach for scalable, robust, optimized solutions maintained in cloud environment. </p>
                        <Row>
                          {
                            projectsDO.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
